<template>
  <vxe-grid
    auto-resize
    highlight-hover-row
    :toolbar-config="tableToolbar"
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :height="tableHeight"
    size="small"
    resizable
    border
    :seq-config="{
      startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
    }"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
    <template v-slot:syncStatus="{ row }">
      <el-tag
        size="mini"
        :type="
          row.syncStatus === 'N'
            ? 'info'
            : row.syncStatus === 'Y'
            ? 'success'
            : row.syncStatus === 'F'
            ? 'danger'
            : 'warning'
        "
      >
        {{ row.v_syncStatus }}
      </el-tag>
    </template>
    <template v-slot:replyStatus="{ row }">
      <el-tag
        size="mini"
        :type="
          row.replyStatus === 'N'
            ? 'info'
            : row.replyStatus === 'Y'
            ? 'success'
            : 'danger'
        "
      >
        {{ row.v_replyStatus }}
      </el-tag>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="'查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'detail',
                code: row.syncCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          v-allow="'actPush'"
          content="推送"
          placement="top"
        >
          <i class="el-icon-position tool-btn" @click="push(row.syncCode)"></i>
        </el-tooltip>
      </div>
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">暂无数据！</p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
    }
  },
  methods: {
    push(syncCode) {
      this.$confirm('确认要重新推送该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        this.$api
          .thdapiIyeedOrderStatusSyncPushApi({ syncCode })
          .then((res) => {
            loading.close()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => loading.close())
      })
    },
    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'openapi-statusSync-detail',
        params: { ...params, pageType },
      })
    },
  },
}
</script>
